import { connect } from 'react-redux';
import CollapseableSectionView from './collapseable_section_view';

const mapStateToProps = () => ({
});

const CollapseableSectionContainer = connect(mapStateToProps)(CollapseableSectionView);

export default CollapseableSectionContainer;
